/**
 * Early Mail day rows on /home, in date order, as each day's request finishes.
 *
 * Each day is its own request and a big race day can take far longer than the
 * others (Melbourne Cup eve 2026: ~35 s vs ~6 s), so a day that is ready is
 * shown straight away and a day still loading keeps its place with a small
 * "Loading <Day>'s Early Mail..." line.
 *
 * @param {Array<{ date: string, isLoading: boolean }>} queries - one per day, in display order
 * @param {Array<{ date: string, tracks: Array }>} readyDays - days that loaded with at least one track
 * @returns {Array<{ date: string, state: "loading" } | { date: string, state: "ready", day: object }>}
 *   Days that loaded empty or failed are left out.
 */
export function buildFutureTipsSlots(queries, readyDays) {
  const readyByDate = new Map(
    (Array.isArray(readyDays) ? readyDays : []).map((day) => [day.date, day]),
  );
  const slots = [];
  for (const q of Array.isArray(queries) ? queries : []) {
    if (!q?.date) continue;
    const day = readyByDate.get(q.date);
    if (day) slots.push({ date: q.date, state: "ready", day });
    else if (q.isLoading) slots.push({ date: q.date, state: "loading" });
  }
  return slots;
}
